import { useState, Suspense } from "react";
import AdminPlatformPoliciesList from "../../components/admin/AdminPlatformPoliciesList.jsx"
import { Link, useParams } from "react-router-dom";

export default function PlatformPolicyListPage() {
  const [tournamentFullName, setTournamentFullName] = useState()
  const {tournamentId} = useParams()

  const setTournamentFullNameOnLoad = (newTournamentName) => {
    setTournamentFullName(newTournamentName)
  }

  return (
    <section className="m-8">
      <div className="flex flex-row w-full">
        <h1 className="w-1/2">List of Platform Policies: { tournamentFullName ? tournamentFullName : '' }</h1>
        <div className="w-1/2 text-end">
          <Link className="text-blue-500 underline hover:no-underline text-sm" to={`/cocofantoelefanto/tournaments/${tournamentId}/platform-policies/new`}>Create New Platform Policy</Link>
        </div>
      </div>

      <div id="teams" className={`w-full pt-4'`}>
        <Suspense fallback={<p>Carregando...</p>}>
          <AdminPlatformPoliciesList tournamentId={tournamentId} setTournamentFullNameOnLoad={setTournamentFullNameOnLoad}/>
        </Suspense>
      </div>
    </section>
  )
}
